module.exports = __webpack_public_path__ + "img/suv.2ab45465.png";